module.exports = __webpack_public_path__ + "static/media/supernova.35883f84.png";